import React from 'react';
import { Plus } from 'lucide-react';
import HabitatAssayLozenges, { HabitatAssayLozengeOption } from 'src/shared/components/lozenges/HabitatAssayLozenges';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import { AppName } from 'src/global/globalConfig';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';
import { SecondaryButton } from 'src/shared/components/button/Button';
import Show from 'src/shared/components/show/Show';
import useBoolean from 'src/shared/hooks/useBoolean';
import UploadDataModal from 'src/shared/components/upload-data-modal/UploadDataModal';

const DashboardDataSources = () => {
    const [showImportModal, setShowImportModal] = useBoolean(false);
    const {
        currentProjectSelectedHabitatAssayType: habitatAssayType,
        currentProjectFilters,
        setCurrentProjectHabitatAssayType,
    } = useProjectFilters();

    const nmHabitatAssayOptions: HabitatAssayLozengeOption[] = [];
    const thirdPartyHabitatAssayOptions: HabitatAssayLozengeOption[] = [];

    currentProjectFilters?.habitatAssayTypeOptions.forEach(entry => {
        const habitatOption = {
            habitatName: entry.habitatName,
            assayName: entry.assayName,
            value: entry.value,
            provider: entry.provider,
            source: entry.source,
        };

        if (entry.provider === 'NatureMetrics') {
            nmHabitatAssayOptions.push(habitatOption);
        } else {
            thirdPartyHabitatAssayOptions.push(habitatOption);
        }
    });

    return (
        <>
            <div className='flex mb-5 gap-5 flex-wrap'>
                <div className='flex flex-col gap-[6px] flex-[1_auto_auto] border-r border-grey-20 pr-5'>
                    <div className='flex text-primary items-center'>
                        NatureMetrics data sources <QuestionButtonHelp type='api' placement='right' slug='nm-data-sources' />
                    </div>
                    <Show
                        when={nmHabitatAssayOptions.length > 0}
                        fallback={<span className='bg-grey-20 text-white text-center font-bold w-[70px] py-3 rounded-full'>None</span>}
                    >
                        <HabitatAssayLozenges
                            options={nmHabitatAssayOptions}
                            selectedValue={habitatAssayType?.key || ''}
                            onChange={setCurrentProjectHabitatAssayType}
                            app={AppName.DASHBOARD}
                            className='flex gap-[6px] flex-wrap'
                            autoReset={false}
                            showEdnaOnly={false}
                        />
                    </Show>
                </div>
                <div className='flex flex-col gap-[6px] flex-[1_1_auto]'>
                    <div className='flex text-primary items-center'>
                        Imported data sources <QuestionButtonHelp type='api' placement='right' slug='imported-data-sources' />
                    </div>
                    <div className='flex gap-[6px]'>
                        {thirdPartyHabitatAssayOptions.length > 0 && (
                            <HabitatAssayLozenges
                                options={thirdPartyHabitatAssayOptions}
                                selectedValue={habitatAssayType?.key || ''}
                                onChange={setCurrentProjectHabitatAssayType}
                                app={AppName.DASHBOARD}
                                className='flex gap-[6px]'
                                showThirdParty={true}
                                autoReset={false}
                                showEdnaOnly={false}
                            />
                        )}
                        <SecondaryButton className='flex gap-1 rounded-full font-bold py-5' onClick={setShowImportModal.on}>
                            <Plus /> Import Data (beta)
                        </SecondaryButton>
                    </div>
                </div>
            </div>

            {showImportModal && <UploadDataModal onClose={setShowImportModal.off} />}
        </>
    );
};

export default DashboardDataSources;
